import React from 'react';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import SalaryCalculatorApp from '../components/SalaryCalculator';
import SeoHeaders from "../components/SeoHeaders";

function SalaryCalculator() {
  return (
    <React.Fragment>

      <SeoHeaders
          supportedCountries={['mt']}
          title={"[country] Salary Calculator | Buddy"}
          description={"Check your salary instantly and see how much you should receive. Use this calculator for a free salary estimation based on actual payroll calculations."}
      />
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="grid grid-cols-2 sm:grid-cols-12 mx-auto max-w-screen-xl">

          <div className="col-span-10">
            <div className="max-w-7xl mx-auto py-4 px-4 sm:py-4 sm:px-6 lg:px-8 sm:text-center md:text-left lg:flex lg:justify-between">
              <div className="max-w-xl">
                <h2 className="text-4xl font-extrabold text-white sm:text-5xl sm:tracking-tight lg:text-6xl">
                  Salary Calculator
                </h2>
                <p className="mt-5 text-xl text-gray-400">
                  Malta's only employer-friendly salary calculator, based on actual payroll calculations.
                </p>
              </div>
            </div>
          </div>
          <SalaryCalculatorApp />
        </div>
      </main>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalaryCalculator)